import routes from './router';
import store from './store/';
import '@/assets/css/global.css'
import "cy_static/js/libs/rem.js";

const router = new VueRouter({
	routes,
	strict: process.env.NODE_ENV !== 'production',
	scrollBehavior: () => ({ y: 0 })
})

router.beforeEach((to, from, next) => {
    var fullPath = to.fullPath
    var nowUrl = spm.sliceBefore(document.URL, '#')
    var spmUrl = spm.addSpm(nowUrl, spm.getPageCode()) + '#' + fullPath
    var toPathName = to.name;
    switch (toPathName) {
        case 'confirm':
            spm.setPageCode('102651', {title:"订单确认", pageName:"产品-限时活动畅由商品订单确认页", dept:"产品"});
            spm.push(['_trackPageview', spmUrl])
            next();
            break
		case 'killDetail':
			spm.setPageCode('102650', {title:"商品详情", pageName:"产品-限购活动商详页cps商品", dept:"产品"});
			spm.push(['_trackPageview', spmUrl])
			next();
			break
		case 'pddFreeDetail':
			spm.setPageCode('102648', {title:"商品详情", pageName:"产品-限时活动商详页cps0元购", dept:"产品"});
			spm.push(['_trackPageview', spmUrl])
			next();
			break
		case 'pddBuyDetail':
			spm.setPageCode('102649', {title:"商品详情", pageName:"产品-限购活动商详页cps商品", dept:"产品"});
			spm.push(['_trackPageview', spmUrl])
			next();
			break
        default:
            next()
    }
})
new Vue({
	router,
	store,
	data() {
		return {
		}
	},
	methods: {

	},
}).$mount('#app')

